import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from "@angular/core";
import { S25Util } from "../util/s25-util";
import { TypeManagerDecorator } from "../main/type.map.service";
import { Report } from "../pojo/Report";
import ReportFormat = Report.ReportFormat;

@TypeManagerDecorator("s25-ng-report-file-type")
@Component({
    imports: [],
    selector: "s25-ng-report-file-type",
    template: `
        @if (init) {
            <div class="c-margin-left--double">
                <label class="c-margin-bottom--half">
                    <label [for]="id">Report Format:</label>
                    <select
                        [id]="id"
                        class="cn-form__control c-margin-top--quarter c-margin-left--half"
                        (change)="changeType($event)"
                    >
                        @for (f of reportFormatList; track f) {
                            <option [value]="f.itemId">
                                {{ f.itemName }}
                            </option>
                        }
                    </select>
                </label>
            </div>
        }
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class S25ReportFileTypeComponent implements OnInit {
    @Input() formatType?: ReportFormat.PDF;
    @Input() reportId?: number;
    @Input() onChange: (obj: any) => any = undefined;
    @Output() modelValueChange = new EventEmitter();

    static count: number = 0;
    id: string;
    init: boolean = false;
    reportFormatList = [
        { itemId: 2, itemName: "PDF" },
        { itemId: 4, itemName: "Excel" },
        { itemId: 6, itemName: "Rich Text" },
        { itemId: 1, itemName: "HTML" },
        { itemId: 3, itemName: "Text" },
    ];

    constructor(
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef,
    ) {
        this.elementRef.nativeElement.angBridge = this; //bridge to AngularJS; used for AngJS to set model values and call setter fns
        this.id = "ngFileType-" + S25ReportFileTypeComponent.count++;
    }

    ngOnInit() {
        this.init = true;
        this.cd.detectChanges();
    }

    changeType(e: any) {
        this.formatType = parseInt(e.target.value);
        let data = { formatType: this.formatType, reportId: this.reportId };
        this.onChange && S25Util.isFunction(this.onChange) && this.onChange(data); // hook into JS
        this.modelValueChange.emit(data);
    }
}
